import { isArray, isPlainObject, map, mapKeys, mapValues, snakeCase } from 'lodash';

const containsNumber = (key) => /\d/.test(key);

const mapKeysDeep = (obj, fn) => {
    if (isArray(obj)) return map(obj, (inner) => mapKeysDeep(inner, fn));

    if (isPlainObject(obj)) return mapValues(mapKeys(obj, fn), (value) => mapKeysDeep(value, fn));

    return obj;
};

const convertKeysToSnakeCase = (obj, convertKeysWithNums = false) =>
    mapKeysDeep(obj, (_, key) => {
        if (!convertKeysWithNums && containsNumber(key)) return key;

        return snakeCase(key);
    });

export default convertKeysToSnakeCase;
